import Grid from '@material-ui/core/Grid'
import Input from 'Components/Input'
import Search from 'Components/Search'
import Select from 'Components/Select'
import User from 'EurestoClass/User'
import DataComponent from 'EurestoComponents/DataComponents'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import React from 'react'



class SearchClient extends React.Component {

  constructor(props) {
    super(props)

    const requestSearch = EurestoClone(props.search)
    if (requestSearch['$or']) {
      requestSearch.famille_id = props.search['$or']['gst_famille.id']
    }
    if (requestSearch['gst_famille.id']) {
      requestSearch.sfamille_id = props.search['gst_famille.id']
    }
    delete requestSearch['$or']
    delete requestSearch['gst_famille.id']


    this.state = {
      search: requestSearch,
      key: Utils.getRandomNumber(),
    }
  }

  search = async (data, name, e, event) => {
    const search = this.state.search
    search[name] = data
    console.log(search)

    const requestSearch = EurestoClone(search)



    if (name === '?affichage') {
      if (data === 1) {
        requestSearch['_gst_fiche_technique_info.id'] = 1
      } else if (data === -1) {
        requestSearch['_gst_fiche_technique_info.id'] = 0
      } else {
        delete requestSearch['_gst_fiche_technique_info.id']
      }
    }

    if (requestSearch.famille_id) {
      delete requestSearch.famille_id
      requestSearch['$or'] = {
        'gst_famille.id': search.famille_id,
        'gst_famille.famille_id': search.famille_id
      }
    } else {
      delete requestSearch.$or
    }

    if (requestSearch.sfamille_id) {
      delete requestSearch.sfamille_id
      requestSearch['gst_famille.id'] = search.sfamille_id
    } else {
      delete requestSearch['gst_famille.id']
    }
    console.log(requestSearch)

    this.setState({
      search: search,
    }, () => this.props.searching && this.props.searching(requestSearch))
  }

  render() {
    return (
      <Grid key={this.state.key} container spacing={0} style={{ margin: 0, padding: 5, overflow: 'visible' }}
        justify={'flex-start'}
        alignItems={'stretch'}
        alignContent={'flex-start'}
        direction={'column'}>
        <Input
          autoFocus={true}
          onChange={this.search}
          name="libelle"
          type="text"
          className="upText"
          value={this.state.search.libelle}
          title={EurestoI18n.t('crm:Nom')}
        />
        {this.state.search.type_produit_id !== 3 && <DataComponent
          title={EurestoI18n.t('crm:Rubrique')}
          name="rubrique_id"
          type={Constants.typeSaisie.ComboSimple}
          onChange={this.search}
          data={this.state.search.rubrique_id}
          object={Constants.donnee.rubrique}
          module={Constants.module.GESTION}
          search={{ type: this.state.search.type_produit_id !== 4 ? 1 : 2 }}
        />}
        {this.state.search.type_produit_id !== 3
          && this.state.search.type_produit_id !== 4
          && this.state.search.type_produit_id !== 5 &&
          <Select
            title={EurestoI18n.t('commun:Affichage')}
            name="?affichage"
            options={[{
              label: EurestoI18n.t('commun:Tous'),
              value: 0
            }, {
              label: EurestoI18n.t('gestion:Avec FT'),
              value: 1
            }, {
              label: EurestoI18n.t('gestion:Sans FT'),
              value: -1
            }]}
            default={0}
            value={this.state.search['?affichage']} onChange={this.search} />}
        <DataComponent
          title={this.state.search.type_produit_id !== 4 ? EurestoI18n.t('gestion:Famille') : EurestoI18n.t('gestion:Région')}
          name="famille_id"
          type={Constants.typeSaisie.ComboSimple}
          onChange={this.search}
          data={this.state.search.famille_id}
          object={Constants.donnee.famille}
          module={Constants.module.GESTION}
          search={{ famille_id: null, type: this.state.search.type_produit_id !== 4 ? 1 : 2 }}
        />
        {this.state.search.famille_id && <DataComponent
          title={this.state.search.type_produit_id !== 4 ? EurestoI18n.t('gestion:Sous-Famille') : EurestoI18n.t('gestion:Suos-Région')}
          key={this.state.search.famille_id}
          name="sfamille_id"
          type={Constants.typeSaisie.ComboSimple}
          onChange={this.search}
          data={this.state.search.sfamille_id}
          object={Constants.donnee.famille}
          module={Constants.module.GESTION}
          search={{ famille_id: null, type: this.state.search.type_produit_id !== 4 ? 1 : 2 }}
          search={{ famille_id: this.state.search.famille_id }}
        />}
      </Grid>
    )
  }

}

export default class extends React.Component {

  render() {
    return <Search raz={true} defaultSearch={this.props.defaultSearch} path={'gestion'} requete={'produit'}
      search={this.props.search || 'gestion_produit_' + (this.props.name || '') + User.Entite.get().id}>
      <SearchClient />
    </Search>
  }

}



// WEBPACK FOOTER //
// ./app/App/Module/Gestion/Component/Search/Produit.js